export function DashboardService($http, apexApiUrl, utilityService) {
    'ngInject'
    return {
        retrieveDashboards: retrieveDashboards,
        retrieveDashboardData: retrieveDashboardData,
        retrieveModifiedTimeEntries: retrieveModifiedTimeEntries,
        retrieveTimeEntryModifications: retrieveTimeEntryModifications,
        acknowledgeTimeEntryModification: acknowledgeTimeEntryModification,
        dismissTimeEntryModification: dismissTimeEntryModification
    };

    function retrieveDashboards(dashboards, exclude) {
        return $http.get(apexApiUrl + "home/dashboards", {
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data.filter(function (dashboard) {
                    let matchedDashboards = true;
                    if (dashboards) {
                        // Return false if none of the dashboards match.
                        matchedDashboards = false;
                        for (let i = 0; i < dashboards.length; i++) {
                            if (dashboardsMatch(dashboards[i], dashboard)) {
                                matchedDashboards = true;
                            }
                        }

                        if (!matchedDashboards) {
                            return false;
                        }
                    }
                    if (exclude) {
                        // Return false if the current dashboard matched the blacklist.
                        for (let i = 0; i < exclude.length; i++) {
                            if (dashboardsMatch(exclude[i], dashboard)) {
                                return false;
                            }
                        }
                    }
                    return true;
                });
            });
    }

    function dashboardsMatch(dashboardTemplate, dashboard) {
        return dashboardTemplate.moduleID === dashboard.ModuleID
            || dashboardTemplate.title === dashboard.Title
            || dashboardTemplate.dashboardID === dashboard.DashboardID;
    }

    function retrieveDashboardData(dataUrl) {
        return $http.get(apexApiUrl + dataUrl)
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Retrieve the collection of modified time entries that are to be displayed on
     * the logged in user's dashboard.
     */
    function retrieveModifiedTimeEntries() {
        return $http.get(apexApiUrl + "time-entries/modified", {
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data.map(function (modification) {
                    // Convert modification from timespan to 12 h time.
                    modification.StartTime = utilityService.utility.convertTimeTo12h(modification.StartTime);
                    modification.EndTime = utilityService.utility.convertTimeTo12h(modification.EndTime);
                    return modification;
                });
            });
    }

    /**
     * Retrieve the collection of time entries modified by the logged in user.
     */
    function retrieveTimeEntryModifications() {
        return $http.get(apexApiUrl + "time-entries/modifications", {
            headers: {
                Accept: "application/json"
            }
        })
            .then(function (response) {
                return response.data;
            });
    }

    /**
     * Acknowledge a modification made to a time entry for this user by their employer.
     */
    function acknowledgeTimeEntryModification(timeEntryModificationID) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "time-entries/modified/" + timeEntryModificationID + "/acknowledge",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify({
                timeEntryModificationID: timeEntryModificationID
            })
        });
    }

    /**
     * Dismiss a modification made by the authenticated employee. The employee whose time entry
     * was modified will still have to acknowledge it.
     */
    function dismissTimeEntryModification(timeEntryModificationID) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "time-entries/modifications/" + timeEntryModificationID + "/dismiss",
            headers: {
                "Content-Type": "application/json"
            },
            data: JSON.stringify({
                timeEntryModificationID: timeEntryModificationID
            })
        });
    }
}
